import { type FC, useEffect, useState } from 'preact/compat';

import clsx from 'clsx';

import { LOADING_TIME_FOR_GAMES__NOT_INTEGRATED } from '@/entities/buttons/play-button/constants';
import { useProgress } from '@/entities/playdeck/models/playdeck.store';

import { useAppState } from '@/shared/stores/app-store/app-store';
import { Lottie } from '@/shared/ui/lottie';

import gamepadLottie from '@/assets/lotties/gamepad.lottie?url';

import { LoadingOverlay } from './LoadingOverlay';

import s from './index.module.scss';

interface Props {
  className?: string;
  pdOpen: boolean;
  showProgress?: boolean;
}

const PROGRESS_INTERVAL = 750;
const PROGRESS_END = 100;

export const Preloader: FC<Props> = ({ className, pdOpen, showProgress = false }) => {
  const [visibleProgress, setVisibleProgress] = useState(0);
  const progress = useProgress();
  const { game } = useAppState();

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleProgress((prev) => {
        if (prev < PROGRESS_END) {
          return prev + 1;
        }
        return prev;
      });
    }, PROGRESS_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (game?.flags.noIntegration) {
      setTimeout(() => {
        setVisibleProgress(PROGRESS_END);
      }, LOADING_TIME_FOR_GAMES__NOT_INTEGRATED);
    }
  }, [game?.flags.noIntegration]);

  useEffect(() => {
    setVisibleProgress(progress);
  }, [progress]);

  return (
    <>
      {showProgress && (
        <div className={clsx(s['progress-container'], !pdOpen && s.disappearance)}>
          <Lottie src={gamepadLottie} className={s.lottie} loop autoplay />
          <div className={s.progress}>{Math.trunc(visibleProgress)}%</div>
        </div>
      )}
      <LoadingOverlay className={className} pdOpen={pdOpen} progress={progress} />
    </>
  );
};
